import { createAction, props } from '@ngrx/store';

import { LastPageStateWithTabs } from '@store/types/basic-last-page-state';

import { DriverItem, DriversList } from '../../app/portal/pages/drivers/drivers.types'; // export const getDrivers = createAction('[Drivers] Get');

// export const getDrivers = createAction('[Drivers] Get');
// export const storeDrivers = createAction('[Drivers] Store', props<{ list: any }>());

export const loadDrivers = createAction('[Drivers] Load Drivers');

export const loadDriversSuccess = createAction(
  '[Drivers] Load Drivers Success',
  props<{ list: DriversList }>(),
);

export const loadDriversFailure = createAction(
  '[Drivers] Load Drivers Failure',
  props<{ error: string }>(),
);

export const addDriver = createAction('[Drivers] Add Drivers', props<{ driver: DriverItem }>());
export const updateDriver = createAction(
  '[Drivers] Update Drivers',
  props<{ id: number; changes: Partial<DriverItem> }>(),
);
export const updateMultipleDrivers = createAction(
  '[Drivers] Update Multiple Drivers',
  props<{ updates: { id: number; changes: Partial<DriverItem> }[] }>(),
);
export const deleteDriver = createAction('[Drivers] Delete Drivers', props<{ id: string }>());

export const setLastPageStateDrivers = createAction(
  '[stateDrivers] Set last page state',
  props<{ newPageState: Partial<LastPageStateWithTabs> }>(),
);
